import { useState } from "react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { Calculator, Send } from "lucide-react";
import PackagePriceCalculator from "./PackagePriceCalculator";
import { EnhancedQuoteForm } from "./EnhancedQuoteForm";

interface PackageCalculatorWithQuoteProps {
  packageId: number;
  packageName: string;
}

const PackageCalculatorWithQuote = ({ packageId, packageName }: PackageCalculatorWithQuoteProps) => {
  const [totalPrice, setTotalPrice] = useState(0);
  const [quoteDetails, setQuoteDetails] = useState<any>(null);
  const [showQuoteForm, setShowQuoteForm] = useState(false);
  const [calculatorOpen, setCalculatorOpen] = useState(false);

  const handlePriceChange = (price: number, details: any) => {
    setTotalPrice(price);
    setQuoteDetails(details);
  };

  const handleRequestQuote = () => {
    if (!quoteDetails) {
      return;
    }
    setCalculatorOpen(false);
    setShowQuoteForm(true);
  };

  return (
    <>
      {/* Calculator Dialog */}
      <Dialog open={calculatorOpen} onOpenChange={setCalculatorOpen}>
        <DialogTrigger asChild>
          <Button variant="outline" className="flex items-center gap-2">
            <Calculator className="w-4 h-4" />
            Calculate Price
          </Button>
        </DialogTrigger>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Calculator className="w-5 h-5 text-shell-primary" />
              Package Calculator - {packageName}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-6">
            <PackagePriceCalculator
              packageId={packageId}
              packageName={packageName}
              onPriceChange={handlePriceChange}
            />
            
            {totalPrice > 0 && (
              <div className="flex items-center justify-between pt-4 border-t">
                <div>
                  <p className="text-sm text-muted-foreground">Estimated Total</p>
                  <p className="text-2xl font-bold text-shell-primary">${totalPrice.toFixed(2)}</p>
                </div>
                <Button onClick={handleRequestQuote} className="flex items-center gap-2">
                  <Send className="w-4 h-4" />
                  Request Quote
                </Button>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Quote Form Dialog */}
      <Dialog open={showQuoteForm} onOpenChange={setShowQuoteForm}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Send className="w-5 h-5 text-shell-primary" />
              Request Quote - {packageName}
            </DialogTitle>
          </DialogHeader>
          {quoteDetails && (
            <EnhancedQuoteForm
              packageName={packageName}
              packageId={packageId}
              totalPrice={totalPrice}
              quoteDetails={quoteDetails}
              onClose={() => setShowQuoteForm(false)}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PackageCalculatorWithQuote;